import { Component } from '@angular/core';

import { Platform, NavController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Storage } from '@ionic/storage';
import { AngularFireAuth } from '@angular/fire/auth';



import {firebase} from '@firebase/app';
import '@firebase/messaging';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {

 

  constructor(private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    public storage: Storage,
    public afAuth: AngularFireAuth,
    public navCtrl: NavController,) {

    firebase.initializeApp(environment.firebase);

    this.initializeApp();

    this.afAuth.authState
          .subscribe(
            user => {
              if (user) {
                
              } else {
                this.navCtrl.navigateRoot('login',{replaceUrl: true});
              }
            },
            () => {
             
              this.navCtrl.navigateRoot('login',{replaceUrl: true});
            }
            );
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      if (window.navigator.onLine) {
        this.storage.set('networkState', 1);
      } else {
        this.storage.set('networkState', 0);
      }

     // this.requestPermission();;
    });
  }


  /*
  requestPermission(): Promise<void> {
    return new Promise<void>(async (resolve) => {
        if (!Notification) {
            resolve();
            return;
        }
        if (!firebase.messaging.isSupported()) {
            resolve();
            return;
        }
        try {
            const messaging = firebase.messaging();
            await messaging.requestPermission();

            const token: string = await messaging.getToken();

            console.log('User notifications token:', token);
        } catch (err) {
          console.log('User notifications token:', err);
        }

        resolve();
    });
  }

  */
  
  
}
